import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { ApiError } from '../api/client'
import { deviceTabsQuery, today, type Period } from '../api/securitee'
import { Content } from '../ui/Shell'
import { SecuriteeDeviceTabs } from './DeviceTabs'
import { PeriodFilter } from './DevicesPage'
import './device-page.css'

/**
 * Securitee > All devices > un aparat (`/securitee/all_devices/$id`): filele
 * randului desfacut din All devices, pe o pagina a lor. Aici duc legaturile
 * spre aparat din Incidents, Detections si EDR events - lista All devices
 * n-ar ajuta, fiindca ascunde aparatele fara modulul Securitee si pe cele din
 * alt sediu. Fila sta in adresa (`?tab=`), ca Back si o adresa trimisa sa
 * deschida tot ea.
 */
export function SecuriteeDevicePage({ id, tab, onTab }: { id: number; tab?: string; onTab?(key: string): void }) {
  const [period, setPeriod] = useState<Period>(() => ({ from: today(), to: today() }))
  const tabs = useQuery(deviceTabsQuery(id))
  const name = tabs.data?.device.name || `Device #${id}`
  const missing = tabs.error instanceof ApiError && tabs.error.status === 404

  return (
    <Content>
      <div id="content" className="xdr-device-page">
        <div className="xdr-device-page-head">
          <a className="btn btn-sm btn-default xdr-device-page-back" href="/app/securitee/all_devices">
            <i className="fa fa-arrow-left" aria-hidden="true"></i> All devices
          </a>
          <h1 className="xdr-device-page-title">
            <i className="fas fa-desktop" aria-hidden="true"></i> <span className="xdr-device-page-name">{name}</span>
          </h1>
          {!missing && (
            <nav className="xdr-device-page-links" aria-label="This device elsewhere">
              <a className="btn btn-sm btn-default xdr-device-page-incidents" href={`/app/securitee/incidents?device=${id}`}>
                <i className="fa fa-bolt" aria-hidden="true"></i> Incidents
              </a>
              <a className="btn btn-sm btn-default xdr-device-page-card" href={`/app/inventoree/device/${id}`}>
                <i className="fa fa-id-card" aria-hidden="true"></i> Device card
              </a>
            </nav>
          )}
          {!missing && <PeriodFilter period={period} onChange={setPeriod} />}
        </div>
        {missing ? (
          <div className="alert alert-warning xdr-device-page-missing" role="alert">
            Device #{id} is not in the company selected in the header. Select its company in the header, then open it again.
          </div>
        ) : (
          <SecuriteeDeviceTabs id={id} period={period} tab={tab} onTab={onTab} />
        )}
      </div>
    </Content>
  )
}
